import { render } from "./LoadingComp.vue?vue&type=template&id=24a43bf6"
import script from "./LoadingComp.vue?vue&type=script&lang=js"
export * from "./LoadingComp.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__